import React, { Component } from 'react';
import PropTypes from 'prop-types';
import mixpanel from 'mixpanel-browser';
import { SocialButton, SocialWrapper, Title } from './ShareButtons.css';
import { SocialImg } from '../../css_global/utils.css';
import { TrackingEvents } from '../../../common/models';
import { unlocalizePath } from '../../../helpers/hrefLocation';

const shareData = [
  {
    buttonImg: 'mkt/icon/social_facebook_black.png',
    title: 'Facebook',
    url: ({ encodedUrl }) => `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`
  },
  {
    buttonImg: 'mkt/icon/social_twitter_black.png',
    title: 'Twitter',
    url: ({ twitterTitle, encodedUrl }) =>
      `https://twitter.com/intent/tweet?text=${twitterTitle}&url=${encodedUrl}&via=italistofficial`
  },
  {
    buttonImg: 'mkt/icon/social_pinterest_black.png',
    title: 'Pinterest',
    url: ({ encodedUrl, img, fbOgTitle }) =>
      `http://www.pinterest.com/pin/create/button/?url=${encodedUrl}&media=${img}&description=${fbOgTitle}`
  }
];

class ShareButtons extends Component {
  constructor(props) {
    super(props);
    this.state = { encodedUrl: null };
  }

  componentDidMount() {
    shareData.forEach(({ title }, index) => {
      mixpanel.track_links(`#${title}-${index}`, TrackingEvents.italistSocialShareSelected(), {
        platform: title
      });
    });

    this.setState({ encodedUrl: encodeURIComponent(`${unlocalizePath(window.location.href)}`) });
  }

  render() {
    const {
      margin,
      s3BasePath,
      isDesktop,
      img,
      fbOg: { title: fbOgTitle },
      twitter: { title: twitterTitle }
    } = this.props;
    const { encodedUrl } = this.state;
    return (
      <SocialWrapper margin={margin} isDesktop={isDesktop}>
        <Title isDesktop={isDesktop}>Share:</Title>
        {shareData.map(({ buttonImg, title, url }, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <SocialButton isDesktop={isDesktop} key={`${title}-${index}`}>
            <a
              id={`${title}-${index}`}
              href={url({ encodedUrl, img, title, twitterTitle, fbOgTitle })}
              target="_blank"
              rel="noopener noreferrer"
            >
              <SocialImg index={index} src={`${s3BasePath}${buttonImg}`} width="20px" />
            </a>
          </SocialButton>
        ))}
      </SocialWrapper>
    );
  }
}

ShareButtons.propTypes = {
  isDesktop: PropTypes.bool,
  margin: PropTypes.string,
  s3BasePath: PropTypes.string.isRequired,
  img: PropTypes.string.isRequired,
  fbOg: PropTypes.object,
  twitter: PropTypes.object
};

export default ShareButtons;
